interface ButtonProps {
  id?: string;
  type?: "button" | "submit" | "reset";
  rounded?: string;
  bgColour?: string;
  textColour?: string;
  border?: string;
  borderColour?: string;
  className?: string;
  fontWeight?: string;
  children: React.ReactNode;
  onClick?: (e: any, onClickArgs: any) => void;
  onClickArgs?: any[];
  disabled?: boolean;
  paddingY?: string;
  paddingX?: string;
  width?: string;
  shadow?: string;
}

export default function Button({
  id = "",
  type = "submit",
  rounded = "full",
  bgColour = "yellow",
  textColour = "dark-grey",
  border = "2",
  borderColour = "yellow",
  className = "",
  fontWeight = "bold",
  children,
  onClick = () => { },
  onClickArgs = [],
  disabled = false,
  paddingY = "1",
  paddingX = "4",
  width = "full",
  shadow = "none"
}: ButtonProps) {
  return (
    <button
      id={id}
      type={type}
      className={`group relative flex w-${width} justify-center items-center rounded-${rounded} border-${border} border-${borderColour} bg-${bgColour} hover:brightness-90 py-${paddingY} px-${paddingX} text-xs sm:text-sm font-${fontWeight} text-${textColour} shadow-${shadow} ${className}`}
      onClick={(e) => (onClick === undefined ? null : onClick(e, onClickArgs))}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
